// removed by extract-text-webpack-plugin
module.exports = {"base":"_39TCGUKmH-0z4rCRC0zdhR","icon":"_39b88IgGef1rRbrCGWahEG","baseText":"L60_VpAMz7zytpM8u107h","bolderText":"_2GVEoLAP8iC0g05PWh3VuH","buying":"dO5S1x2_tDC-wEQsfH6El","selling":"_22BKiW0sAbW5Nr10-qonqq","detailsAmountCol":"_1WS2Lm1_ntBVOzPGWplmA6","detailsTradingCol":"_2n5n10017WOJCbM_yB0B1z","detailsTradingFirstCol":"_3Cl0PVL_uZjMmaXblnCt-U","tradingStatus":"_1uSMSQkf7d1dxSGa--C6XP","active":"_1D6WXDcVjOm68vqjCkjEIR","disabled":"TJu--qz5wQx3TZdWx4bYu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisSoldReceivedAmounts.scss
// module id = 478
// module chunks = 0